// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function TableDateCell(props) {
  let label = props.label;
  let value = props.value;
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(TextStyle.make, {
        children: value !== undefined ? I18n.dateTimeFormat(undefined, "short", undefined, undefined, undefined, undefined, undefined, undefined, undefined, value) : "—"
      }),
      label !== undefined ? JsxRuntime.jsx(TextStyle.make, {
          children: "(" + label + ")",
          variation: "normal",
          size: "xxsmall"
        }) : null
    ],
    space: "none"
  });
}

let make = React.memo(TableDateCell);

export {
  make,
}
/* make Not a pure module */
